import React from 'react';
import { Container } from './styles';
import { VoucherIcon } from '../../../../components/icons';
import { formatThousands } from '../../../../utils';

type Props = {
    totalAmountAvailable: number;
}

const TotalBalance: React.FC<Props> = ({ totalAmountAvailable }) => {
    return (
        <Container >
            <div >
                <VoucherIcon />
                <label>Saldo total disponível</label>
            </div>
            <div>
                <span>{formatThousands(totalAmountAvailable)}</span>
                <label>cortesias</label>
            </div>
        </Container>
    );
};

export { TotalBalance };
